import { render, staticRenderFns } from "./MobileSolveCompliance.vue?vue&type=template&id=2cd87dee&scoped=true&"
import script from "./MobileSolveCompliance.vue?vue&type=script&lang=js&"
export * from "./MobileSolveCompliance.vue?vue&type=script&lang=js&"
import style0 from "./MobileSolveCompliance.vue?vue&type=style&index=0&id=2cd87dee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd87dee",
  null
  
)

export default component.exports